import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";

import { URGI_DOCTOR_LOGO } from "../../constants";
import { getUserData } from "../../utils/localStorage";

const Header = ({ showLogin = true, personalisedExperience }) => {
  const userData = getUserData();
  return (
    <div>
      <img
        src={
          userData?.logo_url ||
          (personalisedExperience?.logo?.length > 0 &&
            URL.createObjectURL(personalisedExperience?.logo?.[0])) ||
          URGI_DOCTOR_LOGO
        }
        style={{
          width: 92,
          height: 94,
        }}
        className={classNames(
          "float-md-left",
          `${showLogin && "float-left  p-3"}`
        )}
        alt="img"
      />
    </div>
  );
};

const mapStoreToProps = ({ onboarding }) => ({
  personalisedExperience: onboarding.personalisedExperience,
});

export default connect(mapStoreToProps, undefined)(Header);
